import React from 'react';

import clsx from 'clsx';

import styles from './StatusMessage.module.scss';

interface StatusMessageProps {
  message: string;
  className?: string;
  startAdornment?: () => JSX.Element;
  startAdornmentClassname?: string;
  endAdornment?: () => JSX.Element;
  endAdornmentClassname?: string;
}

const StatusMessage = ({
  message,
  className,
  startAdornment,
  startAdornmentClassname,
  endAdornment,
  endAdornmentClassname,
}: StatusMessageProps) => {
  return (
    <>
      <div className={clsx(styles.container, className)}>
        {startAdornment && <div className={startAdornmentClassname}>{startAdornment()}</div>}
        <div className={styles.message}>{message}</div>
        {endAdornment && <div className={endAdornmentClassname}>{endAdornment()}</div>}
      </div>
    </>
  );
};

export default StatusMessage;
